module.exports = __webpack_public_path__ + "img/mail-bulk.3b65c22d.svg";